import { __assign, __rest } from "tslib";
import clsx from 'clsx';
import React from 'react';
import { getBaseProps } from '../internal/base-component';
import styles from './styles.css.js';
export default function Container(_a) {
    var _b;
    var header = _a.header, disableHeaderPaddings = _a.disableHeaderPaddings, footer = _a.footer, children = _a.children, disableContentPaddings = _a.disableContentPaddings, restProps = __rest(_a, ["header", "disableHeaderPaddings", "footer", "children", "disableContentPaddings"]);
    var baseProps = getBaseProps(restProps);
    return (React.createElement("div", __assign({}, baseProps, { className: clsx(baseProps.className, styles.root) }),
        header && (React.createElement("div", { className: clsx(styles.header, disableHeaderPaddings && styles['header-no-paddings']) }, header)),
        React.createElement("div", { className: clsx(styles.content, (_b = {},
                _b[styles['content-no-paddings']] = disableContentPaddings,
                _b[styles['content-has-header']] = header,
                _b)) }, children),
        footer && React.createElement("div", { className: styles.footer }, footer)));
}
